// Check for empty list or dicts
export const isEmpty = (iterable) => iterable ? Object.keys(iterable).length < 1 : true;

// Date utils START
const dateToLocaleString = (date) => date.toLocaleString('en-GB', { timeZone: "Asia/Singapore" }).split(/\D/);
export const dateToString = (date) => {
  const DATE = dateToLocaleString(date);
  return `${DATE[2]}-${DATE[1]}-${DATE[0]}`; 
};
const getNewDate = () => dateToLocaleString(new Date());
export const getCurrentDate = () => dateToString(new Date());
export const getCurrentTime = () => {
  const DATE = getNewDate();
  return `${DATE[4]}:${DATE[5]}:${DATE[6]}`;
};
export const periodToTime = (period) => 
  `${String(Math.floor((period-1)/2%24)).padStart(2, 0)}:${period % 2 === 0 ? "30" : "00"}`;
export const timeToPeriod = (time) => {
  const res = /(?<hour>\d{2}):(?<minute>\d{2}):(\d{2})/.exec(time);
  return res ? res.groups.hour*2 + Math.floor(res.groups.minute/30) + 1 : 0;
}
export const getCurrentPeriod = () => timeToPeriod(getCurrentTime());
// Date utils END

export const roundTo2dp = (val) => (Math.round(val*100)/100).toFixed(2);

// Login state START
export const setLoginStatus = (isLoggedIn) => sessionStorage.setItem("isLoggedIn", isLoggedIn ? "true" : "false");

export const isLoggedIn = () => sessionStorage.getItem("isLoggedIn") === "true";
// Login state END

export function clearLoginStatus() {
  // Clear all cookies
  const cookies = document.cookie.split(";");

  cookies.forEach(cookie => {
    const cookieName = cookie.split("=")[0].trim();
    console.log(cookieName)
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  });

  // Clear localStorage
  localStorage.clear();

  // Clear sessionStorage
  sessionStorage.clear();

  // Clear Cache API
  if (window.caches) {
    caches.keys().then(keyList => {
      return Promise.all(keyList.map(key => caches.delete(key)));
    });
  }

  console.log('Logged out, window cache cleared')
}